import { useQuery } from 'react-query'
import { over, lensProp } from 'ramda'

import services from '../services/flashcardSets'

const responseWithoutExcludedSets = excludedIds => data => {
  if (!excludedIds || excludedIds.length === 0) {
    return data
  }

  return over(
    lensProp('flashcardSets'),
    sets => sets?.filter(set => !excludedIds.includes(set.id)),
    data
  )
}

export default function useFlashcardSets({
  exclude = [],
  enabled = true,
} = {}) {
  const { isLoading, data, refetch } = useQuery(
    'flashcardSets',
    () => services.getFlashcardSets().then(response => response.data),
    {
      select: responseWithoutExcludedSets(exclude),
      enabled,
    }
  )

  return {
    isLoading,
    data,
    refetch,
  }
}
